<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="608px"
    title="修改直送方式"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :before-close="cancel"
  >
    <el-form
      ref="form"
      class="form"
      :model="form"
      :rules="rules"
      label-position="top"
    >
      <el-form-item label="直送类型" prop="deliveryType">
        <el-radio-group
          v-model="form.deliveryType"
          @input="form.code = ''"
        >
          <el-radio-button
            v-for="item in tabItems"
            :key="item.id"
            :label="item.id"
          >{{ item.name }}</el-radio-button
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.deliveryType !== 0" label="仓库" prop="code">
        <el-select
          v-model="form.code"
          style="width: 100%"
          filterable
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in warehouseList"
            :key="item.label"
            :label="item.label"
            :value="item.label"
          >

            <span style="float: left">{{ item.label }}</span>
            <span
              style="
                                  float: right;
                                  color: #8492a6;
                                  font-size: 13px;
                                "
            >
              {{ item?.address | formatStatusAddress }}
              {{ item?.city | formatStatusAddress }}
              {{ item?.provinceEnName | formatStatusAddress }}
              {{ item?.countryName | formatStatusAddress }}
              <strong>{{
                                  item?.postcode ? item?.postcode : ""
              }}</strong>
            </span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else prop="expressSupplier">
        <div class="supplyList" style="width: 220px">
          <div
            v-for="(
              item, $index
            ) in config.expressSupplierOptions"
            :key="item.value"
            class="item"
            :class="{ active: kdSupplyIndex === $index }"
            @click="kdSupplyIndex = $index"
          >
            <img
              :src="require(`@/assets/images/serverSupply/${item.value.toLowerCase()}.png`)"
              class="logoUrl"
            />
          </div>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div class="ok flex_c_c" @click="ok('form')">确定</div>
    </span>
  </el-dialog>
</template>
<script>
import { modifyDeliverySendWay } from '@/api/bill'
import { mapGetters } from 'vuex'
import config from '@/utils/config'
export default {
  filters: {
    formatStatusAddress(val) {
      return val ? val + ',' : ''
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      config,
      form: {
        deliveryType: '',
        code: ''
      },
      rules: {
        deliveryType: [{ required: true, message: '请选择直送类型', trigger: 'change' }],
        code: [{ required: true, message: '请选择仓库', trigger: 'change' }]
      },
      tabItems: [
        {
          name: '快递商',
          id: 0
        },
        {
          name: '亚马逊仓',
          id: 1
        },
        {
          name: '私仓',
          id: 2
        },
        {
          name: '沃尔玛仓',
          id: 102
        }
      ],
      kdSupplyIndex: 0
    }
  },
  computed: {
    ...mapGetters([
      'addressBookOptions'
    ]),

    // 亚马逊仓
    AMZWarehouseList() {
      return (
        this.addressBookOptions[this.rowData.companyId] ||
        this.addressBookOptions[0] || []
      )
        .filter((a) => a.type === 1)
        .map((item) => {
          item.label = `${item.code}`
          return item
        })
    },
    // 沃尔玛仓
    WrmWarehouseList() {
      return (
        this.addressBookOptions[this.rowData.companyId] ||
        this.addressBookOptions[0] || []
      )
        .filter((a) => a.type === 100)
        .map((item) => {
          item.label = `${item.code}`
          return item
        })
    },
    warehouseList() {
      const companyWarehouseList = (
        this.addressBookOptions[this.rowData.companyId] ||
        this.addressBookOptions[0] || []
      ).filter((a) => a.type === 0 && a.companyId === this.rowData.companyId)
      const arr = companyWarehouseList.map((item) => {
        item.label = `${item.code}`
        return item
      })
      if (this.form.deliveryType === 1) {
        return this.AMZWarehouseList
      } else if (this.form.deliveryType === 102) {
        return this.WrmWarehouseList
      } else {
        return arr
      }
      // return this.form3.deliveryType === 1 ? this.AMZWarehouseList : arr
    }
  },
  watch: {
   async dialogVisible(value) {
      if (value) {
        // 0 = UPS(UPS), 1 = FedEx(FedEx), 2 = Amazon(亚马逊仓), 3 = Private(私仓), 4 = Owner(自提), 5 = Reserved(留仓), 100 = Other(其它), 101 = USPS(USPS), 102 = Walmart(沃尔玛仓), 103 = SelfSupport(自营仓)
        switch (this.rowData.type) {
          case 0: this.form.deliveryType = 0; this.kdSupplyIndex = 0; break
          case 1: this.form.deliveryType = 0; this.kdSupplyIndex = 1; break
          case 2: this.form.deliveryType = 1; this.kdSupplyIndex = 0; this.form.code = this.rowData.code; break
          case 3: this.form.deliveryType = 2; this.kdSupplyIndex = 0; this.form.code = this.rowData.code; break
          case 102: this.form.deliveryType = 102; this.kdSupplyIndex = 0; this.form.code = this.rowData.code; break
        }
      await this.$store.dispatch('getAddressBookOptions', {
          type: -1,
        companyId: 0
        })
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const params = {
            directDelivery: {
              deliveryType: this.form.deliveryType,
              wareHouse: this.form.deliveryType === 0 ? undefined : this.warehouseList.find(a => a.label === this.form.code),
              express: this.form.deliveryType === 0 ? {
                expressSupplier: this.config.expressSupplierOptions[this.kdSupplyIndex]?.value
              } : undefined
            },
            mblSendWayId: this.rowData.id,
            containerNo: this.rowData.containerNumber
          }
          try {
            const res = await modifyDeliverySendWay(params)
            if (res.success) {
              this.$message.success('操作成功')
              this.$emit('ok')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.log(error)
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
:deep(.el-dialog__body) {
  padding: 30px 60px;
}

.supplyList {
  width: 100%;
  height: 40px;
  display: flex;
  .item {
    width: 100px;
    height: 40px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #dbe4f2;
    text-align: center;
    position: relative;
    cursor: pointer;
    & + .item {
      margin-left: 16px;
    }
    .logoUrl {
      max-width: 100px;
      max-height: 37px;
      padding-top: 1px;
    }
  }
  .active {
    border: 1px solid rgb(18, 88, 188);
    &::before {
      content: " ";
      width: 0;
      height: 0;
      background: transparent;
      border-top: 13px solid rgb(18, 88, 188);
      border-right: 13px solid rgb(18, 88, 188);
      border-bottom: 13px solid transparent;
      border-left: 13px solid transparent;
      opacity: 1;
      position: absolute;
      top: -1px;
      left: 72px;
      z-index: 1;
    }
    &::after {
      content: " ";
      width: 15px;
      height: 9px;
      background-image: url("~@/assets/images/gou.png");
      background-repeat: no-repeat;
      background-size: 75%;
      position: absolute;
      top: 2px;
      left: 85px;
      z-index: 2;
    }
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  & div {
    width: 160px;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #f2f7ff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dbe4f2;
    color: #7c8db5;
    margin-right: 16px;
    box-sizing: border-box;
  }
  .ok {
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    color: #ffffff;
  }
}
/deep/ .el-form-item__label {
  line-height: 20px;
}
</style>
